import {trim} from 'lodash';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal, Input} from 'components';
import {useIsChangedTo, useObservable} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';
import {authDataStore} from 'services';
import {IpInfo} from 'types';
import {isValidIpV4, isValidIpV6} from 'utils';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS;

type Props = {
    open: boolean;
    onClose: (confirm: boolean, data: IpInfo) => void;
}

export const AddIpModal: React.FC<Props> = ({open, onClose}) => {
    const {t} = useTranslation();
    const {localUser} = useObservable(authDataStore);
    const [ip, setIp] = useState('');
    const [description, setDescription] = useState('');
    const modalOpened = useIsChangedTo(open, true);
    const ipValid = useMemo(() => isValidIpV4(ip) || isValidIpV6(ip), [ip]);

    const handleAdd = useCallback((confirm: boolean) => {
        let fullInfo = null;
        if (confirm) {
            fullInfo = {
                ip,
                description,
                createdBy: localUser.eid,
                createdAt: new Date()
            };
        }

        onClose(confirm, fullInfo);
    }, [ip, description, localUser, onClose]);

    useEffect(() => {
        if (modalOpened) {
            setIp('');
            setDescription('');
        }
    }, [modalOpened]);

    return (
        <ConfirmModal
            okDisabled={!ipValid}
            open={open}
            title={t(T_KEYS.IP_WHITELIST.MODAL.CREATE)}
            onClose={handleAdd}
        >
            <Input
                className='tw-mb-4'
                hasError={!!ip && !ipValid}
                label={t(T_KEYS.IP_WHITELIST.HEADERS.IP)}
                value={ip}
                onChange={(value: string) => setIp(trim(value))}
            />
            <Input
                label={t(T_KEYS.IP_WHITELIST.HEADERS.DESCRIPTION)}
                value={description}
                onChange={setDescription}
            />
        </ConfirmModal>
    );
};